import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AthletePhotosRoutingModule } from './athlete-photos-routing.module';
import { BootstrapAthletePhotosComponent } from './components/bootstrap-athlete-photos/bootstrap-athlete-photos.component';
import { CommonPageComponentsModule } from 'src/app/common-page-components/common-page-components.module';
import { ServicesModule, ComponentsModule } from 'world-archery-lib';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FilterAthletePhotosServiceService } from './services/filter-athlete-photos-service.service';

@NgModule({
  declarations: [BootstrapAthletePhotosComponent],
  imports: [
    CommonModule,
    AthletePhotosRoutingModule,
    CommonPageComponentsModule,
    ComponentsModule,
    NgbModule
  ],
  providers:[
    FilterAthletePhotosServiceService
  ]
})
export class AthletePhotosModule { }
